import Vue from 'vue';
import Router from 'vue-router';

import guestRoutes from './guest';
import userRoutes from './user';
import adminRoutes from './admin';
import moderatorRoutes from './moderator';

import PageNotFound from '../views/PageNotFound.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    ...guestRoutes,
    ...userRoutes,
    ...adminRoutes,
    ...moderatorRoutes,
    {path: '*', component: PageNotFound},
  ],
});
